import { render, staticRenderFns } from "./MediaIntroduction.vue?vue&type=template&id=ba07cf28&scoped=true&"
import script from "./MediaIntroduction.vue?vue&type=script&scoped=true&lang=js&"
export * from "./MediaIntroduction.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba07cf28",
  null
  
)

export default component.exports